import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    position: {
      margin: '0',
      color: palette.text.white,
      marginTop: '20px',
      fontWeight: 700,
      fontSize: '2rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
